// Hook för att hämta valutakurser från Supabase (public.currency_rates)
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { CurrencyCode } from './types';
import type { Database } from '@/lib/supabase/database.types';

// Typ för rad i tabellen
// (lägg till i database.types.ts om den saknas)
type CurrencyRateRow = Database['public']['Tables']['currency_rates']['Row'];

export type CurrencyRates = Record<CurrencyCode, number>;

// Hook för att hämta valutakurser från Supabase
export function useCurrencyRates() {
  return useQuery({
    queryKey: ['currency-rates'],
    queryFn: async () => {
      // Hämta alla rader från currency_rates
      const { data, error } = await supabase.from('currency_rates').select('code,rate');
      if (error) throw error;
      // Gör om till { USD: 0.09, ... }
      const rates: Partial<CurrencyRates> = {};
      (data as CurrencyRateRow[])?.forEach(row => {
        rates[row.code as CurrencyCode] = Number(row.rate);
      });
      return rates as CurrencyRates;
    },
  });
}
